import party1 from "../images/party1.jpeg";
import party2 from "../images/party2.jpeg";
import party3 from "../images/party3.jpeg";

const partyArray = () => {
  return [party1, party2, party3];
};

export default partyArray();
